// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tableImg p {\n  margin: 0;\n  max-height: 180px;\n  overflow: hidden;\n}\n.tableImg img {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
